export const shippingCommitment = [
    // { value: 'past', name: 'گذشته', checked: false },
    // { value: 'today', name: 'امروز', checked: false },
    { value: 'past-and-today', name: 'گذشته و امروز', checked: false },
    // { value: 'tomorrow', name: 'فردا', checked: false },
    { value: 'future', name: 'فردا به بعد', checked: false },
]

export const warehouses = [
    { _id: '635946cbfbe55055bc53be9b', name: 'اصفهان جی', id: '97', checked: false },
    { _id: '635946cbfbe55055bc53be92', name: 'استاد معین', id: '74', checked: false },
    { _id: '635946cbfbe55055bc53be8a', name: 'ترانسفو', id: '70', checked: false },
    { _id: '635946cbfbe55055bc53be82', name: 'زرین', id: '69', checked: false },
    { _id: '635946cbfbe55055bc53be79', name: 'بادامک (کالاهای کوچک)', id: '58', checked: false },
    { _id: '635946cbfbe55055bc53be71', name: 'کرج', id: '51', checked: false },
    { _id: '635946cbfbe55055bc53be69', name: 'فتح', id: '40', checked: false },
    { _id: '635946cbfbe55055bc53be61', name: 'دانش', id: '1', checked: false },
    { _id: '635946cafbe55055bc53be59', name: 'شرق۱', id: '41', checked: false }
]

export const daysOfWeek = [
    { value: 0, name: 'شنبه', checked: false },
    { value: 1, name: '۱شنبه', checked: false },
    { value: 2, name: '۲شنبه', checked: false },
    { value: 3, name: '۳شنبه', checked: false },
    { value: 4, name: '۴شنبه', checked: false },
    { value: 5, name: '۵شنبه', checked: false },
    { value: 6, name: 'جمعه', checked: false },
]

export const deliverTimeRange = [
    { value: '09:00 - 10:00', id: 0 },
    { value: '10:00 - 11:00', id: 1 },
    { value: '11:00 - 12:00', id: 2 },
    { value: '12:00 - 13:00', id: 3 },
    { value: '13:00 - 14:00', id: 4 },
    { value: '14:00 - 15:00', id: 5 },
    { value: '15:00 - 16:00', id: 6 },
]

export const createPackageFrequency = [
    // { name: 'فقط یک بار', value: 'once', checked: false },
    { name: 'هر روز', value: 'everyday', checked: false },
    { name: 'انتخاب روز در هفته', value: 'specificDays', checked: false },
]


export const createPackageTime = [
    { value: '00:00', id: 0, name: '۰۰:۰۰' },
    { value: '01:00', id: 1, name: '۰۱:۰۰' },
    { value: '02:00', id: 2, name: '۰۲:۰۰' },
    { value: '03:00', id: 3, name: '۰۳:۰۰' },
    { value: '04:00', id: 4, name: '۰۴:۰۰' },
    { value: '05:00', id: 5, name: '۰۵:۰۰' },
    { value: '06:00', id: 6, name: '۰۶:۰۰' },
    { value: '07:00', id: 7, name: '۰۷:۰۰' },
    { value: '08:00', id: 8, name: '۰۸:۰۰' },
    { value: '09:00', id: 9, name: '۰۹:۰۰' },
    { value: '10:00', id: 10, name: '۱۰:۰۰' },
    { value: '11:00', id: 11, name: '۱۱:۰۰' },
    { value: '12:00', id: 12, name: '۱۲:۰۰' },
    { value: '13:00', id: 13, name: '۱۳:۰۰' },
    { value: '14:00', id: 14, name: '۱۴:۰۰' },
    { value: '15:00', id: 15, name: '۱۵:۰۰' },
    { value: '16:00', id: 16, name: '۱۶:۰۰' },
    { value: '17:00', id: 17, name: '۱۷:۰۰' },
    { value: '18:00', id: 18, name: '۱۸:۰۰' },
    { value: '19:00', id: 19, name: '۱۹:۰۰' },
    { value: '20:00', id: 20, name: '۲۰:۰۰' },
    { value: '21:00', id: 21, name: '۲۱:۰۰' },
    { value: '22:00', id: 22, name: '۲۲:۰۰' },
    { value: '23:00', id: 23, name: '۲۳:۰۰' },
]

export const deliverType = [
    { value: 'seller', id: 0, name: 'تحویل توسط فروشنده' },
    { value: 'mobile_hub', id: 1, name: 'تحویل به انبار سیار' },
]